<template>
  <div v-if="visible"
    class="confirm-modal-overlay tw-fixed tw-w-full tw-h-full tw-top-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-z-[9999] tw-bg-[#02050A90] max-lg:tw-py-4 max-lg:tw-px-0"
    @click.self="handleOverlayClick">
    <div
      :class="['confirm-modal-box tw-bg-[#02060c] md:tw-px-12 md:tw-py-8 tw-px-4 tw-pb-4 tw-pt-6 tw-flex tw-flex-col tw-rounded-[24px] tw-text-center tw-w-full tw-mx-4 tw-border tw-border-[#26292f]', contentMaxWidthClass]">
      <div class="tw-flex tw-flex-col tw-gap-2 md:tw-gap-4">
        <h2 class="tw-m-0 tw-font-bold tw-text-white tw-text-[24px] md:tw-text-[32px] tw-leading-[1.2]">{{ title }}</h2>

        <div class="tw-flex tw-flex-col tw-gap-2 md:tw-gap-4">
          <p v-for="(text, i) in descriptionList" :key="i"
            class="tw-m-0 tw-text-[16px] md:tw-text-[18px] tw-leading-[1.3] tw-text-[#F5F8FFB2]">
            {{ text }}
          </p>
          <slot v-if="$slots.default" />
        </div>
      </div>

      <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 md:tw-gap-3 tw-mt-4 md:tw-mt-8 tw-justify-center">
        <!-- Primary action (yellow) = confirm -->
        <button v-if="!hideSecondaryButton" type="button"
          class="tw-flex md:tw-hidden tw-justify-center tw-items-center tw-w-full md:tw-w-[160px] tw-h-[44px] tw-border-none tw-font-semibold tw-text-base tw-leading-6 tw-rounded-[24px] tw-cursor-pointer tw-transition-all tw-duration-200 tw-bg-[#FFEF46] tw-text-[#02050A] hover:tw-opacity-90"
          @click="handleConfirm">
          {{ primaryButtonLabel }}
        </button>

        <!-- Secondary action (grey) = cancel -->
        <button type="button"
          class="tw-flex tw-justify-center tw-items-center tw-w-full md:tw-w-[160px] tw-h-[44px] tw-border-none tw-font-semibold tw-text-base tw-leading-6 tw-rounded-[24px] tw-cursor-pointer tw-transition-all tw-duration-200 tw-bg-[#23262B] tw-text-[#F5F8FF] hover:tw-opacity-90"
          @click="handleCancel">
          {{ secondaryButtonLabel }}
        </button>

        <!-- Primary action (yellow) = confirm -->
        <button v-if="!hideSecondaryButton" type="button"
          class="md:tw-flex tw-hidden md:tw-justify-center tw-items-center tw-w-full md:tw-w-[160px] tw-h-[44px] tw-border-none tw-font-semibold tw-text-base tw-leading-6 tw-rounded-[24px] tw-cursor-pointer tw-transition-all tw-duration-200 tw-bg-[#FFEF46] tw-text-[#02050A] hover:tw-opacity-90"
          @click="handleConfirm">
          {{ primaryButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    descriptions: {
      type: [String, Array],
      default: () => [],
    },
    /** Label for primary action (yellow button, emits onConfirm) */
    primaryButtonLabel: {
      type: String,
      required: true,
    },
    /** Label for secondary action (grey button, emits onCancel) */
    secondaryButtonLabel: {
      type: String,
      default: '',
    },
    /** When true, only primary (yellow) button is shown */
    hideSecondaryButton: {
      type: Boolean,
      default: false,
    },
    /** Modal max width: 'dialog' (592px), 'preview' (884px), 'md' (448px), 'lg' (512px) */
    size: {
      type: String,
      default: 'dialog',
      validator: (v) => ['md', 'lg', 'dialog', 'preview'].includes(v),
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    contentMaxWidthClass() {
      const map = {
        md: 'tw-max-w-md',
        lg: 'tw-max-w-lg',
        dialog: 'tw-max-w-[592px]',
        preview: 'tw-max-w-[884px]',
      };
      return map[this.size] || map.dialog;
    },
    descriptionList() {
      if (Array.isArray(this.descriptions)) {
        return this.descriptions;
      }
      return this.descriptions ? [this.descriptions] : [];
    },
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    /** Click outside modal (on overlay) always cancels/closes, never confirms */
    handleOverlayClick() {
      this.close();
      this.$emit('onCancel');
    },
    handleConfirm() {
      this.close();
      this.$emit('onConfirm');
    },
    handleCancel() {
      this.close();
      this.$emit('onCancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-modal-overlay {
  animation: confirmModalFadeIn 0.2s ease-out;
}

.confirm-modal-box {
  animation: confirmModalSlideUp 0.3s ease-out;
}

@keyframes confirmModalFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes confirmModalSlideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
